import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Table, TableBody, TableCell, TableContainer, TableRow } from "@mui/material";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";

import TableComponent from "../../components/TableComponent";
import Confirm from "../../components/Confirm";
import OrderItem from "./OrderItem";
import Button from "../../components/Button";
import { getOrders, updateOrder, getTransactionById, getOrderCrew } from "../../api/orders";

function formatDate(string) {
  const date = new Date(string);
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const day = date.getDate();
  const formattedDate = `${day}.${month}.${year}`;
  return formattedDate;
}

const OrdersTable = ({ match, history }) => {
  const { t } = useTranslation();
  const crewId = match.params.crewId;
  const transactionId = match.params.transactionId;

  const [similarCompany, setSimilarCompany] = React.useState([]);
  const [orders, setOrders] = useState([]);
  const [transaction, setTransaction] = useState(null);
  const [selectedOrderId, setSelectedOrderId] = useState(null);
  const [selectedbuyerId, setSelectedbuyerId] = useState(null);
  const [isDeleteModalShow, setIsDeleteModalShow] = useState(false);
  const [isRefundModalShow, setIsRefundModalShow] = useState(false);
  const [refresh, setRefresh] = useState(1);

  function showDeleteModal(id, buyerId) {
    setSelectedOrderId(id);
    setSelectedbuyerId(buyerId);
    setIsDeleteModalShow(true);
  }

  function showRefundModal(id, buyerId) {
    setSelectedOrderId(id);
    setSelectedbuyerId(buyerId);
    setIsRefundModalShow(true);
  }

  function onEdit(id) {
    history.push(`${match.path}/${id}`);
  }

  async function onStatusChange(id, newStatus) {
    await updateOrder(id, { status: newStatus });
    setRefresh(refresh * -1);
  }

  async function confirmDeleteModal(isConfirmed) {
    if (isConfirmed) {
      await updateOrder(selectedOrderId, {
        status: "cancelled",
        buyerId: selectedbuyerId,
      });
      setRefresh(refresh * -1);
    }
    setIsDeleteModalShow(false);

    setRefresh(refresh * -1);
  }

  async function confirmRefundModal(isConfirmed) {
    if (isConfirmed) {
      await updateOrder(selectedOrderId, {
        status: "refunded",
        buyerId: selectedbuyerId,
      });
      setRefresh(refresh * -1);
    }

    setIsRefundModalShow(false);

    setRefresh(refresh * -1);
  }

  const handleChange = async (event) => {
    const selectedOrders = await getOrderCrew(event.target.value);
    setOrders(selectedOrders);
  };

  useEffect(() => {
    (async () => {
      let newOrders = [];
      if (crewId) {
        newOrders = await getOrderCrew(crewId);
      } else {
        newOrders = await getOrders();
      }
      setOrders(newOrders);

      if (transactionId) {
        const trans = await getTransactionById(transactionId);
        setSimilarCompany(trans.companyListSorted);
        setTransaction(trans);
      }
    })();
  }, [refresh]);

  const goBack = () => history.goBack();
  return (
    <>
      {transaction ? (
        <>
          <h2>{t("transactions_bank.transaction")}</h2>
          <Button title={t("navigate_back")} type="button" onClick={() => history.goBack()}>
            {t("navigate_back")}
          </Button>
          <TableContainer>
            <Table>
              <TableBody>
                <TableRow>
                  <TableCell>{t("orders.new_selection")}:</TableCell>
                  <TableCell>
                    <Select
                      labelId="demo-simple-select-standard-label"
                      id="demo-simple-select-standard"
                      // TODO: this looks weird
                      value=""
                      onChange={handleChange}
                      label={t("training_pages.crew")}
                    >
                      {similarCompany.map((option) => (
                        <MenuItem key={option.id} value={option.id}>
                          {option.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>{t("orders.crew_from_transaction")}:</TableCell>
                  <TableCell>{transaction.company}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>{t("price")}:</TableCell>
                  <TableCell>{transaction.price}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>{t("transactions_bank.booking_date")}:</TableCell>
                  <TableCell>{formatDate(transaction.bookg_date)}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>{t("transactions_bank.validity_date")}:</TableCell>
                  <TableCell>{formatDate(transaction.validity_date)}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>{t("transactions_bank.info")}:</TableCell>
                  <TableCell>
                    {transaction.tranaction_info.split("; ").map((i, key) => {
                      return <div key={key}>{i}</div>;
                    })}
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </>
      ) : (
        ""
      )}

      <h2>{t("orders.title")}</h2>
      <TableComponent
        header={[
          { title: t("orders.id"), sort: "id", style: { width: "5%" } },
          { title: t("training_pages.crew"), sort: "crew" },
          { title: t("orders.buyer"), sort: "buyer", style: { width: "10%" } },

          { title: t("orders.items"), sort: "items" },
          { title: t("orders.paid_with"), sort: "payment_type" },
          { title: t("orders.total"), sort: "total", style: { width: "5%" } },
          { title: t("orders.date"), sort: "date", style: { width: "10%" } },
          { title: t("orders.status"), sort: "status", style: { width: "7%" } },
          { title: t("orders.set_to_paid"), style: { width: "5%" } },
          { title: t("actions"), style: { width: "13%" } },
        ]}
        renderChildren={(order) => (
          <OrderItem
            key={`order-${order.order_id}`}
            onEdit={onEdit}
            onDelete={showDeleteModal}
            onRefund={showRefundModal}
            onStatusChange={onStatusChange}
            order={order}
          />
        )}
        items={orders}
        search={["company_name", "order_id", "total", "status", "buyer"]}
        pagination
      />
      {isDeleteModalShow && selectedOrderId ? (
        <Confirm title={t("orders.delete_order")} onConfirm={confirmDeleteModal}>
          <p>{t("orders.delete_confirm")}</p>
        </Confirm>
      ) : null}
      {isRefundModalShow && selectedOrderId ? (
        <Confirm title={t("orders.refund_order")} onConfirm={confirmRefundModal}>
          <p>{t("orders.refund_confirm")}</p>
        </Confirm>
      ) : null}
    </>
  );
};

export default OrdersTable;
